import { download } from "../../components/AssetLibrary";
import { InlineImage } from "../../components/InlineImage";

/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
function Carpethia() {
  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>Carpéthia</h1>
          <InlineImage image="dnd/LogoVliegendeZwaard.png" border={false} width={175} subscript="Logo orde van het Vliegende Zwaard" />
          <p>
            In de D&D campaign Carpéthia spelen we in de wereld van Carpéthia. De (ons) bekende wereld bestaat uit twee continenten. Er is het naamloze noordelijke continent waar
            een klein aantal grote uitgestrekte landen liggen. Carpéthia is een zeer groot eiland voor de westkust van dit continent. Het zuidelijke continent wordt "Land of a
            Thousand Kingdoms" genoemd, omdat het bezaaid is met kleine stadstaatjes. De twee continenten worden verbonden door een landbrug die de naam Bokolo Seko draagt en die
            bedenkt wordt door een nagenoeg onbegaanbare oerwoud. De handel en het reizen tussen de twee continenten is dus zeer beperkt en geschiedt vrijwel uitsluitend over zee.
          </p>
          <p>
            In Owl's nest, in het land "Thousand Kingdoms", is de orde van het Vliegende Zwaard gevestigd. Dat is een orde onder de leiding van Fluit die zich inzet voor het goede
            in de wereld. Althans, dat is de perceptie bij sommigen. Anderen, en dan specifiek de leden van het huis van het Verborgen Schild, beweren dat deze orde helemaal niet
            zo goed is en feitelijk opgericht is om de demon 'Gladius Volantis' te bevrijden. Zo zijn er momenteel twee groepen; avonturiers die Fluit en de orde dienen en
            avonturiers die Bryndegard (leidster van het huis) dienen.
          </p>
          <p>
            De campaign startte als proefsessies in 2016, vanuit het volleybalteam Ziemniaki. Inmiddels zijn er nog maar 2 bij Ziemniaki spelende spelers die deelnemen aan deze
            campaign.
          </p>
          <p>Meer achtergrondinformatie over deze wereld is te vinden in de volgende documenten:</p>
          <ul>
            <li>{download("dnd/Homebrew - Sun Elves.pdf", "Homebrew - Sun Elves")} </li>
            <li>{download("dnd/Carpethia - People of the Mainland.pdf", "Carpéthia - People of the Mainland")} </li>
          </ul>
        </div>
      </div>
      <div className="box main">
        <div className="row">
          <h1>Jaartelling</h1>
          <ul>
            <li>
              <b>-244</b> De laatste draak, Genus Ultimus, sterft
            </li>
            <li>
              <b>0</b> De Ancient Carpéthians, de lange paarse wezens die het eiland oorspronkelijk bewoonden verdwijnen plotseling. Het eiland wordt gekoloniseerd door inwoners
              van het noordelijke continent en de jaartelling begint.
            </li>
            <li>
              <b>500</b> Een magiër genaamd Unduriël veroorzaakt een magische catastrofe die een significant deel van het noordelijke continent veranderd in een levenloos gebied
              genaamd Ashfall.
            </li>
            <li>
              <b>749</b> Een duistere magiër genaamd de Reaver verovert het noordelijke continent met behulp van een leger ondoden.
            </li>
            <li>
              <b>756</b> De Ancient Carpéthians én de draken komen terug.
            </li>
            <li>
              <b>757</b> Een onbekende groep avonturiers verslaat de Reaver, maar de prijs is hoog: de Ashfall verdubbelt in formaat.
            </li>
            <li>
              <b>762</b> Deze groep avonturiers ontvangt hun eerste opdracht op het noordelijke continent van Ulrikke.
            </li>
            <li>
              <b>767</b> Deze groep avonturiers ontvangt hun eerste opdracht op het zuidelijke continent van Fluit.
            </li>
          </ul>
        </div>
      </div>

      <div className="box light">
        <div className="col41">
          <h1>Kaarten</h1>
          <table className="noborder">
            <tbody>
              <tr>
                <td>
                  <InlineImage image="dnd/Kaart Carpetia.jpg" subscript="Carpéthia" />
                </td>
                <td>
                  <InlineImage image="dnd/Kaart Thousand Kingdoms.png" subscript="Thousand Kingdoms" border={false} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col42">
          <table className="noborder">
            <tbody>
              <tr>
                <td>
                  <InlineImage image="dnd/Kaart regio Filiabad.jpg" subscript="regio Filiabad" />
                </td>
                <td>
                  <InlineImage image="dnd/Kaart Falae.jpg" subscript="Falae" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col43">
          <table className="noborder">
            <tbody>
              <tr>
                <td>
                  <InlineImage image="dnd/Kaart Filiabad.jpg" subscript="Filiabad ✝︎" />
                </td>
                <td>
                  <InlineImage image="dnd/Kaart Groeziabad.jpg" subscript="Groeziabad" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col44">
          <table className="noborder">
            <tbody>
              <tr>
                <td>
                  <InlineImage image="dnd/Kaart Medina.jpg" width="50%" float="left" subscript="Medina" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="box main">
        <div className="left">
          <h2>Proefsessies</h2>
          <h3>Missie</h3>
          <p>
            Oorlogsveteraan Ulrikke vraagt een groep avonturiers die ze via-via kent om haar te helpen een tijdens de Reaver-oorlog gestolen erfstuk voor haar te vinden. Als
            daarbij per ongeluk de demon Bir'Thiogzephon vrijgelaten wordt, vraagt ze om deze demo op te sporen en weer te vangen. Daarna vraagt ze de avonturiers om te voorkomen
            dat de Reaver (een kwaadaardige magiër) wordt geresurrect.
          </p>
          <p>Voor deze proefsessies werden de volgende documenten gedeeld:</p>
          <ul>
            <li>{download("dnd/Carpéthia - Return of the Ancients.pdf", "Carpéthia - Return of the Ancients")} </li>
            <li>{download("dnd/Carpéthia Player's Guide.pdf", "Carpéthia - Player's Guide")} </li>
          </ul>
        </div>
        <div className="right">
          <p>
            <b>Jaar</b>: 2016 - 2017 &nbsp;<b>DM</b>: Paul
          </p>
          <h3>Spelers</h3>
          <p>Jossos (Jos), Malos (Marijn), Krack (Marianne), Naraeth (Joep), Anor (Walter), Vivaneth (Walter), Morrel (Ivo)</p>
          <h3>Spelverloop</h3>
          <p>
            De avonturiers vinden het erfstuk, maar laten per ongeluk de demon Bir'Thiogzephon vrij. De avonturiers slagen er niet in om Bir'Thiogzephon op tijd op te sporen en hij
            brandt de stad Bael Ameno af. De avonturiers komen erachter dat handlagers van de Reaver haar willen resurrecten. De avonturiers slagen er niet geheel in om de
            resurrection te voorkomen, maar weten deze wel beïnvloeden. De Reaver wordt niet geresurrect als kwaadaardige magiër op het toppunt van haar macht, maar als onbevangen
            18-jarige vrouw zonder herinneringen aan wat ze heeft gedaan.
          </p>
        </div>
      </div>

      <div className="box light">
        <div className="left">
          <h2>Filiabad versus Groeziabad</h2>

          <h3>Missie</h3>
          <p>
            Onder de stad Filiabad ligt een enorme goudader. Elranstopia, een op macht beluste Elvenvrouw, heeft die goudader ontdekt en heeft een plan bedacht om die goudader op
            te graven en slechts met een paar anderen te delen. Ze wil een oorlog ontketenen met Groeiziabad, een nabijgelegen stad die berucht staat om het plunderen van steden
            uit wraak als hen onrecht is aangedaan. Als de stad platgebrand en geplunderd is wil ze de drie toegangswegen afsluiten en vervolgens de goudader opgraven in de
            verlaten stad.
          </p>
          <p>
            Een groep avonturiers van de orde wordt uitgenodigd in Filiabad om hen te helpen en krijgen de opdracht om de koning van Groeziabad, koning Zulamun, te vermoorden. Die
            koning zou namelijk kwaadaardig en meedogenloos zijn. Elranstopia wil ervoor zorgen dat die poging mislukt, zodat koning Zulamun kwaad wordt en Filiabad van de kaart
            veegt.
          </p>
        </div>
        <div className="right">
          <p>
            <b>Jaar</b>: 2017-2018 &nbsp;<b>DM</b>: Ivo
          </p>

          <h3>Spelers</h3>
          <p>Elania (Elise), Morrelina (Lonneke), Jossos (Jos), Malos (Marijn), Krack (Marianne), Sanae (Joep), Prospero (Paul), Vivaneth (Walter)</p>

          <h3>Spelverloop</h3>
          <p>
            Het plan van Elranstopia lukt en Filiabad wordt door Groeziabad van de kaart geveegd, met dank aan de groep avonturiers die dat mogelijk maakten. De groep vindt zelf
            overigens dat de missie geslaagd is, want technisch gezien zou er geen sprake zijn van oorlog. Ook onthoofden zij een lijfwacht van koning Zulamun en brachten een
            'bezoek' aan het dievengilde, het huurmoordenaarsgilde en de vrouw (Ivanka) die Jossos eerder had afgewezen. Maar verder ging alles volgens plan.
          </p>
        </div>
      </div>

      <div className="box main">
        <div className="left">
          <h2>Bir’Thiogzephon</h2>

          <h3>Missie</h3>
          <p>
            Een demon genaamd Bir’Thiogzephon demoniseert al tijdenlang het land Falae, gelegen ten noorden van nieuw-Filiabad en Groeziabad. Fluit heeft als leider van de orde van
            het Vliegende Zwaard te horen gekregen dat er een document bestaat waarmee de demo wellicht verslagen zou kunnen worden. Dit document is in 7 delen opgesplitst en de 7
            delen zijn op 7 verschillende locaties verborgen door 7 broers.
          </p>
          <p>
            Een groep avonturiers van de orde wordt op pad gestuurd om alle 7 delen van het document te vinden en het document te herstellen. Vervolgens moet daarmee de demon
            Bir’Thiogzephon verslagen worden.
          </p>
        </div>
        <div className="right">
          <p>
            <b>Jaar</b>: 2018-2019 &nbsp;<b>DM</b>: Ivo
          </p>
          <h3>Spelers</h3>
          <p>Elania (Elise), Morrelina (Lonneke), Jossos✝︎ (Jos), Malos (Marijn), Krack✝︎ (Marianne), Sanae (Joep), Prospero (Paul), Vivaneth (Walter)</p>
          <h3>Spelverloop</h3>
          <p>
            Tijdens het zoeken naar de 7 delen worden diverse broers gemarteld, opgegraven uit hun graf en ontvoerd. Los van een inbraak in een wapenwinkel en het tot zinken
            brengen van een geleend schip zijn er verder geen noemenswaardige incidenten. De groep verblijft langere tijd in de herberg de "Dronken Piraat", gerund door een waard
            die die naam eer aan doet. De groep veroorzaakt de nodige reuring in Falae, waarop Fluit vraagt of het allemaal wat minder kan. Even later worden de leden van een
            kantklosclub geterroriseerd. Om de onschuldige secretaris "Evander" van de club te vinden wordt overal een "wanted" poster opgehangen, waarop geïmpliceerd wordt dat hij
            een seriemoordenaar zou zijn.
          </p>
          <p>
            Jossos en Krack overleven dit avontuur niet, maar de groep weet de demon te verslaan door de echte naam van de demon uit te roepen bij een ritueel; “Birth’ganath iosep
            o’hongorag”.
          </p>
        </div>
      </div>

      <div className="box light">
        <div className="left">
          <h2>Isla Almendra</h2>
          <h3>Missie</h3>
          <p>
            Ten oosten van Owl's Nest ligt de Costa Verano, aan de Zee der Zonneschijn. Daar heeft jarenlang een oorlog gewoed tussen de grootste havenstad aan de kust, Porto
            Verão, en het rijkste eiland, Isla Almendra. Die oorlog ging over welke natie recht had op deze twee items: het Zonneschild en het Zonnezwaard. Om de oorlog te
            beëindigen heeft de Orde van het Vliegende Zwaard deze objecten zes jaar eerder ontvreemd. Ze hebben een wapenstilstand afgedwongen, waarbij is afgesproken dat over zes
            jaar, nu dus, de kroonprins en -prinses van deze twee landen met elkaar zouden trouwen en dat wij aan hen deze wapens zouden teruggeven. Dit huwelijk staat gepland voor
            over twee weken. De avonturiers worden gevraagd om naar Isla Almendra af te reizen voor het huwelijk zodat beide partijen de items op echtheid kunnen checken.
          </p>
        </div>
        <div className="right">
          <p>
            <b>Jaar</b>: 2019 &nbsp;<b>DM</b>: Paul
          </p>
          <h3>Spelers</h3>
          <p>Norah (Elise), Pheza (Jos), Malos (Marijn), Rafa (Marianne), Sanae (Joep), Duntyr (Walter), Faenor (Ivo)</p>
          <h3>Spelverloop</h3>
          <p>
            Als de avonturiers aankomen op Isla Almendra blijkt dat kroonprins Don Thiago de nacht ervoor te zijn ontvoerd uit het koninklijk paleis. Met deze verdwijning komt het
            koninklijke huwelijk en het vredesbestand in gevaar. Als onafhankelijke partij worden de leden van de Orde van het Vliegende Zwaard gevraagd de prins terug te vinden.
          </p>
          <p>
            Uiteindelijk blijkt Don Thiago niet te zijn ontvoerd, maar zelf te zijn ontsnapt, zodat hij met zijn vriendje kan vluchten, omdat hij niet wil trouwen. Uiteindelijk
            overtuigen de avonturiers zijn jongere broer om met de kroonprinses te trouwen, waardoor het vredebestand blijft staan. Ook weten een aantal van de avonturiers de broer
            van de koning van het eiland, die toch al met gokschulden kamt, een klein fortuin afhandig te maken.
          </p>
        </div>
      </div>

      <div className="box main">
        <div className="left">
          <h2>De moeder van Malos</h2>
          <h3>Missie</h3>
          <p>?</p>
        </div>
        <div className="right">
          <p>
            <b>Jaar</b>: 2019-2020 &nbsp;<b>DM</b>: Marijn
          </p>
          <h3>Spelers</h3>
          <p>Norah (Elise), Pheza (Jos), Melodi Wise (Paul), Rafa (Marianne), Sanae (Joep), Duntyr (Walter), Faenor (Ivo)</p>
          <h3>Spelverloop</h3>
          <p>?</p>
        </div>
      </div>

      <div className="box light">
        <div className="left">
          <h2>De piramide van Irphai</h2>

          <h3>Missie</h3>
          <p>Fluit vraagt een groep avonturiers om een aantal gevaarlijke magische objecten uit de pas geopende piramide van Irphai te bemachtigen om ze veilig te stellen.</p>
        </div>
        <div className="right">
          <p>
            <b>Jaar</b>: 2020 (Online)&nbsp;<b>DM</b>: Paul
          </p>
          <h3>Spelers</h3>
          <p>Sajen (Elise), Dagrokk (Jos), Hjuldrom (Marianne), Valvus (Joep), Vaudak (Walter), Kilanderion (Ivo), Red Rock (Marijn)</p>
          <h3>Spelverloop</h3>
          <p>Dat lukt verrassend genoeg ook daadwerkelijk.</p>
        </div>
      </div>

      <div className="box main">
        <div className="left">
          <h2>Egalia Parella</h2>

          <h3>Missie</h3>
          <p>
            De groep krijgt een nieuwe missie van de orde: om de dochter van een koning te redden moeten zij een parel zien te bemachtigen. Om daar meer over te weten te komen gaan
            zij naar Laputa (die met die harpen, hoog in de lucht). Daar blijkt dat de parel zich aan boord van een enorme walvis zou moeten bevinden. Die walvis vliegt in de
            lucht, op zijn rug zijn allerlei dorpjes e.d. De walvis is in feite een metalen machine, met als primaire krachtbron; de parel...
          </p>
        </div>
        <div className="right">
          <p>
            <b>Jaar</b>: 2021-2022 &nbsp;<b>DM</b>: Walter
          </p>
          <h3>Spelers</h3>
          <p>Sajen (Elise), Dagrokk (Jos), Kilanderion (Ivo), Redrock (Marijn), Alejandra (Paul)</p>
          <h3>Spelverloop</h3>
          <p>
            De groep gaat langs Laputa en ontdekt waar de walvis zou moeten zijn. Zij bereiken de walvis en vinden de parel in de 'cockpit' van de walvis. De heldhaftige
            Kilanderion pakt de parel, waarop de walvis een duikvlucht inzet in neerstort in het woud der wanhoop. Maar het goede nieuws is; hij heeft de parel!
          </p>
        </div>
      </div>

      <div className="box light">
        <div className="left">
          <h2>De Meer Hoblins</h2>

          <h3>Missie</h3>
          <p>
            De groep avonturiers van de orde van het Vliegende Zwaard ontvangen een nieuwe missie: zij moeten een kristallen bol zien te bemachtigen die in het bezit is van een
            volk “de Meerhoblins” genaamd, die in een grot leven ergens tussen Groeziabad en de stadstaat Medina in. Die kristallen bol moet terug naar Zulamun, de koning van
            Groeziabad, van wie die bol eigenlijk is. Om bij de Meerhoblins te komen hebben ze de hulp nodig van de sultan van Medina, Murat.
          </p>
          <p>
            Bij deze queeste maken ze kennis met Bryndegard, leidster van het huis van het Verborgen Schild. Zij beweert dat de orde als doel zou hebben om de onsterfelijke demon
            "Gladius Volantis" te bevrijden, die duizend jaar geleden dood en verderf zaaide op deze wereld. Toen hij verslagen werd, werd hij zeer diep in de aarde vastgeketend.
            Precies bovenop die berg zou Owl's nest zich bevinden. "Gladius Volantis" zou drakentaal zijn voor "Het Vliegende Zwaard". "Owl" zou zich in het draaks vertalen naar
            Strix, de grootste aanhanger van de demon draak destijds. En de zoon van Strix, Aulos, zou zich in het Infernal vertalen naar "Fluit".
          </p>
          <p>
            Het is aan de groep avonturiers om een kant te kiezen; trouw blijven aan de orde van het Vliegende Zwaard en diens leider Fluit, of overstappen naar het huis van het
            Verborgen Schild, geleid door Bryndegard.
          </p>
        </div>
        <div className="right">
          <p>
            <b>Jaar</b>: 2022-2023 &nbsp;<b>DM</b>: Ivo
          </p>
          <h3>Spelers</h3>
          <p>Malos (Marijn), Pheza (Jos), Melodi Wise (Paul), Duntyr (Walter) en Norah (Elise)</p>
          <h3>Spelverloop</h3>
          <p>
            De groep weet na het bezoek aan de lokale soek direct een goede indruk bij de sultan van Medina achter te laten, door met een welriekende putlucht / brandlucht te
            verschijnen gekleed in lederhosen en een roze heldenbroek met hartjes. Toch helpt de sultan hen en weten ze met de dochter van de sultan de Meerhoblins te bereiken (de
            dochter overleefd dat overigens niet).
          </p>
          <p>
            Op de terugweg uit de grot komen ze eerst Bryndegard tegen. "Melodi Wise" blijkt dan een anagram te zijn van "Wie is de Mol", en Mel blijkt een spion te zijn die in
            opdracht van Bryndegard met de groep meegegaan is. Bryndegard verteld de groep haar verhaal. Als Fluit dan ook op komt dagen kiest de groep voor kamp Bryndegard en
            stapt over van de orde naar het huis. Ze nemen de kristallen bol mee en vernietigen deze. Daarop keert de stad Aroetem (wat niet geheel toevallig veel weg heeft van het
            griekse Meteora), die in de bol opgesloten zat, terug naar zijn oorspronkelijke locatie. De inwoners van Aroetem zijn blij, koning Zulamun van Groeziabad is minder
            blij.
          </p>
        </div>
      </div>

      <div className="box main">
        <div className="left">
          <h2>De vergeten vallei</h2>

          <h3>Missie</h3>
          <p>
            De missie komt dit keer van het huis van het Verborgen Schild. Fluit is gevlucht en wij moeten hem zoeken. Hij is voor het laatst gezien in de Vergeten Vallei.
            Madriguera zou een vriendin van Fluit zijn en samen met hem gezien zijn. Zij is een professor die de werking van mysterium onderzoekt, een geheimzinnig goedje dat de
            energiebron blijkt te zijn van vele vernuftige apparaten (zoals een vliegende bezem met trappers, een stoomtrein en een pistool).
          </p>
          <p>
            Madriguera weet dat er in de vergeten vallei onder de grond versteende dino's liggen. Als je mysterium gaat minen, dan worden die dino's wakker. Daarom moet men daarmee
            zeer voorzichtig zijn. Maar tegelijkertijd wordt er aan een enorme boor gebouwd, die nog dieper kan graven dan ooit daarvoor. Die boor wil Madriguera vernietigd hebben
            en in ruil daarvoor zal ze de groep helpen.
          </p>
          <p>
            In de vergeten vallei waren speciale spelregels van toepassing, zie{" "}
            {download("dnd/Speciale regels voor de Vergeten Vallei.pdf", "Speciale regels voor de Vergeten Vallei")}
          </p>
        </div>
        <div className="right">
          <p>
            <b>Jaar</b>: 2023-2024 &nbsp;<b>DM</b>: Paul
          </p>
          <h3>Spelers</h3>
          <p>Faeonor✝︎ (Ivo), Lucia B (Marijn), Pheza (Jos), Livy (Janne), Duntyr (Walter)</p>
          <h3>Spelverloop</h3>
          <p>
            Om meer informatie over de "Glumbranche Mining Company" te achterhalen wordt aan boord van een rijdende trein een specifiek pakketje gezocht. "Verkeerde" pakketjes
            worden overboord gegooid, maar Madriguera vindt de juiste. Er volgt een bezoek aan een saloon waar Faenor het niet kan laten om de klep van een piano hard dicht te
            slaan en erop te gaan zitten, met de handen van de piano spelende "Stevie" er nog onder. Er breekt snel een gevecht uit waarop Faenor ontsnapt en Duntyr de boel in de
            fik steekt.
          </p>
          <p>
            In een andere saloon ontmoeten ze een sun elf die werkt voor de Glumbranche Mining Company. Pheza en Faenor achtervolgen haar en breken 's nachts in om haar aan de tand
            te voelen. Dat mislukt jammerlijk en er volgt een klopjacht. Faenor ontsnapt, maar Pheza wordt gegrepen en wacht een rechtszaak. In die zaak wordt ze schuldig bevonden
            aan huisvredebreuk, poging tot kidnapping, poging tot meervoudige moord en diefstal, overval van een trein en minachting van de rechtbank. Daarvoor krijgt ze 2 x
            doodstraf, 1 week werkstraf en 100 goud boete. Gelukkig is het goed weer op de dag van de executie. Tijdens de executie weet Faenor chaos te scheppen door ledematen te
            werpen, een pistool af te vuren en een bom naar Pheza te gooien. Daarop weten Pheza en Faenor te ontsnappen.
          </p>
          <p>
            Als de boor feestelijk onthuld wordt volgt een gevecht waarbij de vijand veel te sterk blijkt. Faenor legt daarbij het loodje. Madriguera wordt gewaarschuwd en die
            verzameld 18 lizard man om de boor te vernietigen. Dat lukt, maar niet voordat Godzilla uit zijn graf is opgestaan. Duntyr en Lucia nemen snel de trein terug naar Owl's
            nest.
          </p>
        </div>
      </div>

      <div className="box light">
        <div className="left">
          <h2>Het Woud der Wanhoop</h2>
          <h3>Missie</h3>
          <p>
            Deze missie is het vervolg van de campaign "Egalia Parella". Bij die missie was de groep op zoek naar een parel. Kilanderion heeft die parel weten te bemachtigen, maar
            door het wegnemen van de parel uit de cockpit van de walvis is deze neergestort in het Woud der Wanhoop. En uit dat woud kun je niet zomaar ontsnappen. De nieuwe missie
            is dus:
          </p>

          <ol>
            <li>Ontsnappen uit het Woud der Wanhoop</li>
            <li>De dochter van de koning redden m.b.v. de parel</li>
          </ol>
          <p>
            De vloek die het Woud der Wanhoop in zijn greep houdt heeft zijn oorsprong bij een bron aan de voet van een grote boom. De bron is verontreinigd waardoor niemand uit
            het woud kan ontsnappen en langzaam veranderd in een dier. Om de bron te reinigen zijn twee opalen nodig, die samengevoegd in de bron geworpen moeten worden.
          </p>
        </div>
        <div className="right">
          <p>
            <b>Jaar</b>: 2024 &nbsp;<b>DM</b>: Walter
          </p>
          <h3>Spelers</h3>
          <p>Alejandra (Paul), Kilanderion✝︎ (Ivo), Sajen (Ivo), Dagrokk (Jos), Red Rock (Marijn), Folen (Janne)</p>
          <h3>Spelverloop</h3>
          <p>
            De groep ontdekt de oorzaak van de vloek en de vermoedelijke locaties van de twee opalen; de ene ligt in Alura (in het noordwesten) en de andere in een tempel. Beide
            opalen worden buitgemaakt, maar Kilanderion sterft tijdens deze operatie. De parel raakt men op magische wijze kwijt, waarop Kilanderion diverse malen opgegraven wordt
            uit zijn graf om te checken of hij de parel echt niet heeft.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Carpethia;
